import React from "react";
import { Divider, Grid2, IconButton, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { RENTLY_R_ICON_COLOR } from "../../../constant/constant";

export const InfoSection = ({ label, value, onEdit }) => {
  return (
    <>
      <Grid2 container spacing={1} sx={{ pt: 2, pl: 4, pr: 4 }}>
        <Grid2 size={4}>
          <Typography variant="body2" color="textSecondary">
            {label}
          </Typography>
        </Grid2>
        <Grid2 size={7}>
          <Typography variant="body2">{value}</Typography>
        </Grid2>
        {label === "Email" || label === "Member Since" ? (
          <Grid2 size={1} sx={{ paddingBottom: 4 }}>
            <span></span>
          </Grid2>
        ) : (
          <Grid2 size={1}>
            <IconButton
              aria-label="update"
              onClick={() => onEdit(label, value)}
            >
              <ChevronRightIcon sx={{ color: RENTLY_R_ICON_COLOR }} />
            </IconButton>
          </Grid2>
        )}
      </Grid2>
      <Divider />
    </>
  );
};
